export const PRODUCTS = [
  {
    slug: "the-inward-ledger",
    name: "The Inward Ledger",
    kind: "Guided workbook · 48 pages",
    price: 18.0,
    currency: "USD",
    description: "A guided self-reflection workbook for the questions you've been walking past. Evening prompts in four movements: Notice, Name, Soften, Choose.",
    inside: [
      "48 printable & fillable pages (PDF)",
      "30 evening reflection prompts",
      "The 'Say it out loud' sentence-starter bank",
      "Weekly look-back spreads"
    ],
    accent: "sage"
  },
  {
    slug: "unclench-audio",
    name: "Unclench",
    kind: "Audio guide · 12 min",
    price: 9.0,
    currency: "USD",
    description: "A 12-minute body-first audio for unclenching jaw, shoulders and mind. Recorded in one take, with long silences left exactly where they belong.",
    inside: [
      "12-min MP3, voice + soft field recordings",
      "3-min emergency cut for the middle of the day",
      "Transcript PDF for reading along"
    ],
    accent: "terra"
  },
  {
    slug: "five-minute-reset-deck",
    name: "The Five-Minute Reset Deck",
    kind: "Digital card deck · 30 cards",
    price: 12.0,
    currency: "USD",
    description: "Thirty micro-practices for the gap between one hard thing and the next. Draw a card, take five minutes, come back as a slightly softer version of yourself.",
    inside: [
      "30 illustrated cards (PDF + phone-sized images)",
      "Sorted by mood: foggy / wired / heavy / restless",
      "Print-friendly & screen-friendly layouts"
    ],
    accent: "pine"
  },
  {
    slug: "the-sleep-journal",
    name: "The Night Scan Journal",
    kind: "4-week wind-down journal",
    price: 15.0,
    currency: "USD",
    description: "A four-week wind-down journal that moves the day out of your head and onto paper, one gentle scan at a time. Built for people who rehearse tomorrow at 1am.",
    inside: [
      "28 dated evening spreads",
      "The Night Scan: a 6-line body & mind check-in",
      "Worry-parking page for tomorrow's business",
      "Printable & tablet-ready (PDF)"
    ],
    accent: "blushdeep"
  }
];
